import Pagination from './Pagination';
import WithPaginator from './WithPaginator';

export { Pagination };
export { WithPaginator };
